import { Client } from './../../models/clients/client.model';
import { Pipe, PipeTransform } from '@angular/core';
import { platformUser } from 'src/app/app.constants';

@Pipe({
  standalone: true,
  name: 'creatorTypeLabel'
})
export class CreatorTypeLabelPipe implements PipeTransform {
  transform(value: any, client?: Client): string {
    let creatorTypeLabel: string;
    if (client) {
      creatorTypeLabel = `${client.firstName} ${client.lastName}`;
    }
    return value === platformUser ? 'Platform User' : creatorTypeLabel;
  }
}
